import React from 'react';
import { ButtonWithIconLeft } from 'koba/components/Button';
import classNames from 'classnames/bind';
import Icon from 'koba/components/Icon';
import styles from './BreadCrumb.module.scss';

interface BreadCrumbProps {
  iconName?: string;
  currentPageType: string;
  goToFunction: () => void;
  buttonTitle?: string;
}
const cx = classNames.bind(styles);
export const BreadCrumb = ({
  iconName,
  currentPageType,
  goToFunction,
  buttonTitle,
}: BreadCrumbProps) => {
  return (
    <div className={cx('breadcrumb')}>
      {buttonTitle && (
        <ButtonWithIconLeft
          appearance="knockout"
          className={cx('breadcrumb__buttons')}
          onClick={() => goToFunction()}
        >
          {iconName && <Icon name={iconName} />}
          {buttonTitle}
        </ButtonWithIconLeft>
      )}
      <p className={cx('breadcrumb__post')}>
        <span className={cx('breadcrumb__divider')}>/</span>
        {currentPageType}
      </p>
    </div>
  );
};
